import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { MultilineTextViewComponent } from './multiline-text-view.component';
import { InputContainerComponent } from '../input-container/input-container.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent],
    selector: 'wd-multiline-text-input',
    templateUrl: 'multiline-text-input.component.html',
    styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class MultilineTextInputComponent extends MultilineTextViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;

	constructor() {
		super();
	}

	override numberOfRows() {
		return this.model ? Math.max(2, this.model.split('\n').length) : 2;
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}
}
